import { ANY_ROOM_TYPE } from 'pages/common/const';
import { getAreaUser } from 'pages/common/helpers/get-area-user.helper';
import { Inputs } from '../types';

const formatValue = (value: string | null): number | null => {
  if (!value) {
    return null;
  }
  return Number(value.replace(/,/g, '.'));
};

type TParams = {
  inputsData: Inputs & { roomType?: string };
  calculationCoefficient?: number;
  calculatorId?: string;
};

export const getProjectUpdatedCustomEventPayload = ({
  inputsData,
  calculationCoefficient,
  calculatorId,
}: TParams) => {
  let projectConfigurationParameters = [];

  if (Boolean(inputsData.roomType) && inputsData.roomType !== ANY_ROOM_TYPE) {
    projectConfigurationParameters.push({
      key: 'roomType',
      value: inputsData.roomType!,
    });
  }

  if (Boolean(inputsData.width) && Boolean(inputsData.length)) {
    projectConfigurationParameters.push({
      key: 'width',
      value: inputsData.width!,
    });
    projectConfigurationParameters.push({
      key: 'length',
      value: inputsData.length!,
    });
  }

  if (Boolean(inputsData.area)) {
    projectConfigurationParameters.push({
      key: 'area',
      value: inputsData.area!,
    });
  } else if (Boolean(inputsData.width) && Boolean(inputsData.length)) {
    projectConfigurationParameters.push({
      key: 'area',
      value: getAreaUser({
        width: formatValue(inputsData.width),
        length: formatValue(inputsData.length),
      }).toString(),
    });
  }

  if (Boolean(inputsData.thickness)) {
    projectConfigurationParameters.push({
      key: 'layingType',
      value: inputsData.thickness!,
    });
  }
  if (calculationCoefficient) {
    projectConfigurationParameters.push({
      key: 'priceCoefficient',
      value: calculationCoefficient.toString(),
    });
  }

  if (calculatorId) {
    projectConfigurationParameters.push({
      key: 'calculatorId',
      value: calculatorId,
    });
  }

  return projectConfigurationParameters;
};
